import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../header';

const SelectCompanyPrompt: FC = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Header>
      <div className="flex flex-col justify-center items-center h-full">
        <Typography variant="h4">{t('select_company_required_header')}</Typography>
        <Typography variant="h5">
          {t('select_company_required_from')}
          <Link to="/app/Accounts">{t('select_company_required_accounts_page_link')}</Link>
        </Typography>
      </div>
    </Header>
  );
};

export default SelectCompanyPrompt;
